export const generateGuid = (): string => {
  let result = "";
  let i;
  let j;
  result = "";
  for (j = 0; j < 32; j += 1) {
    if (j === 8 || j === 12 || j === 16 || j === 20) result += "-";
    i = Math.floor(Math.random() * 16)
      .toString(16)
      .toUpperCase();
    result += i;
  }
  return result;
};

export const capitalize = (s: string): string => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const timeToNumber = (time: string | undefined): number => {
  if (time === undefined) return 0;
  const hoursAndMinutes = time.split(":");
  const hours = parseInt(hoursAndMinutes[0], 10);
  const mins = parseInt(hoursAndMinutes[1], 10) / 60;
  return hours + mins;
};